/* Live Custom Belts — Zees Belts original live configurator. v2, 2026-09-12.
   Vanilla JS, no framework. Geometry: assets/zb-lcb-geom.js. 3D: assets/zb-lcb-3d.js (lazy).
   Catalog: #zb-lcb-data. Product JSON: #zb-lcb-product.
   All customer input is sanitised; only allow-listed values ever reach the cart.
   Prices come from Shopify variants only — nothing the client sends is trusted server-side. */
(function () {
  'use strict';
  var SCHEMA = 'zb-lcb/3';
  var STORAGE = 'zb-lcb:design:v3';
  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var JSPDF_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';

  /* ---------------- tiny DOM helpers ---------------- */
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'text') n.textContent = v;
      else if (k === 'html') n.innerHTML = v;
      else if (k === 'style') n.setAttribute('style', v);
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), v);
      else n.setAttribute(k, v === true ? '' : v);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function once(fn) { var done = false, val; return function () { if (!done) { done = true; val = fn.apply(null, arguments); } return val; }; }
  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.crossOrigin = 'anonymous';
      s.onload = function () { res(); }; s.onerror = function () { rej(new Error('load ' + src)); };
      document.head.appendChild(s);
    });
  }

  function init(root) {
    if (!root || root.dataset.zbInit) return;
    root.dataset.zbInit = '1';
    var $ = function (s, e) { return (e || root).querySelector(s); };
    var $$ = function (s, e) { return Array.prototype.slice.call((e || root).querySelectorAll(s)); };
    var G = window.ZBGeom;
    if (!G) { console.error('[zb-lcb] geometry missing'); return; }

    var DATA, PRODUCT;
    try {
      DATA = JSON.parse(document.getElementById('zb-lcb-data').textContent);
      PRODUCT = JSON.parse(document.getElementById('zb-lcb-product').textContent);
    } catch (e) { console.error('[zb-lcb] data missing', e); return; }
    if (DATA.schema !== SCHEMA) console.warn('[zb-lcb] catalog schema', DATA.schema, 'expected', SCHEMA);

    var CFG = {
      designMode: root.dataset.designMode === 'true',
      debug: /[?&]zbdebug=1/.test(location.search),
      roseGold: root.dataset.roseGold === 'true',
      textures: root.dataset.textures !== 'false',
      addUrl: root.dataset.addUrl || '/cart/add.js',
      cartUrl: root.dataset.cartUrl || '/cart',
      moneyFormat: root.dataset.moneyFormat || '${{amount}}',
      upgradeVariant: root.dataset.upgradeVariant || '',
      upgradeCents: parseInt(root.dataset.upgradeCents || '4500', 10)
    };

    /* ---------------- catalog slices ---------------- */
    var FINISHES = DATA.finishes.filter(function (f) { return f.available || (f.id === 'rosegold' && CFG.roseGold); });
    var STRAPS = DATA.straps.filter(function (s) { return CFG.textures || !s.surcharge; });
    var BANNERS = DATA.banners, STYLES = DATA.bannerStyles, FONTS = DATA.fonts, INKS = DATA.inks;
    var EDGES = DATA.edges, LAYERS = DATA.layers, PLATES = DATA.plates, CLIP = DATA.clipart, CATS = DATA.categories;
    var DUAL = DATA.dualMetals || [{ id: 'gold', name: 'Gold', hex: '#d6a92f' }, { id: 'silver', name: 'Silver', hex: '#c9ced4' }];
    var ZONE_LABEL = DATA.zoneLabels, ZONE_MAX = DATA.zoneMax;
    var TEMPLATES = G.TEMPLATES, LAYOUTS = G.LAYOUTS;
    var PLATE_KEYS = PLATES.map(function (p) { return p.id; });
    var PLATE_OF = {};
    PLATES.forEach(function (p) { p.zones.forEach(function (z) { PLATE_OF[z] = p.id; }); });
    var ZONES = Object.keys(PLATE_OF);
    /* The catalog string is already written as a character-class body (e.g. "A-Za-z0-9 .,'&\\-#!/:()+").
       Use it verbatim; fall back to the default if it will not compile. */
    var ALLOWED;
    try { ALLOWED = new RegExp('[^' + (DATA.textRules.allowed || '') + ']', 'g'); }
    catch (e) { ALLOWED = /[^A-Za-z0-9 .,'&\-#!/:()+]/g; }

    var STEPS = ['template', 'metal', 'strap', 'design', 'banner', 'text', 'plates', 'review'];
    var STEP_TITLE = {
      template: 'Belt shape',
      metal: 'Metal, thickness & layers',
      strap: 'Strap colour & texture',
      design: 'Front-plate layout',
      banner: 'Nameplate style & colour',
      text: 'Lettering & engraving',
      plates: 'Customise each plate',
      review: 'Review & add to cart'
    };
    var STEP_HINT = {
      template: 'Twelve original Zees Belts silhouettes. Every one has a machined gold tip and four snap closures.',
      metal: 'Alloy sets the price. Thicker plates and extra layers add weight and relief.',
      strap: 'Twenty plain leathers plus ten textured hides. Textured adds $45 to the build.',
      design: 'The ornament worked into the centre plate behind your artwork.',
      banner: 'Ribbon is one of seven. You can also engrave straight into the metal.',
      text: 'Up to eight engraved lines across all five plates.',
      plates: 'Artwork, nameplate style and colour, per plate.',
      review: 'Check everything, download your mockup, then add to cart.'
    };

    function byId(arr, id) { for (var i = 0; i < (arr || []).length; i++) if (String(arr[i].id) === String(id)) return arr[i]; return null; }
    function money(cents) {
      var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return CFG.moneyFormat.indexOf('{{amount}}') > -1 ? CFG.moneyFormat.replace('{{amount}}', n)
        : CFG.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, n) || ('$' + n);
    }

    /* ---------------- Shopify variant mapping ---------------- */
    /* Option 1 Metal (alloy family), Option 2 Thickness, Option 3 Plate layers.
       Anything that does not change price/SKU stays a line-item property. */
    var OPT = { alloy: -1, thick: -1, layer: -1 };
    (PRODUCT.options || []).forEach(function (name, i) {
      var n = String(name).toLowerCase();
      if (/metal|alloy|plating|material/.test(n)) OPT.alloy = i;
      else if (/thick|gauge|mm/.test(n)) OPT.thick = i;
      else if (/layer|tier|stack/.test(n)) OPT.layer = i;
    });
    if (OPT.alloy < 0) OPT.alloy = 0;
    if (OPT.thick < 0) OPT.thick = (PRODUCT.options || []).length > 1 ? 1 : -1;
    if (OPT.layer < 0) OPT.layer = (PRODUCT.options || []).length > 2 ? 2 : -1;

    function optVal(v, i) { return i < 0 ? null : (v.options ? v.options[i] : v['option' + (i + 1)]); }
    function valuesFor(which, sel) {
      var out = [], seen = {};
      PRODUCT.variants.forEach(function (v) {
        if (which !== 'alloy' && OPT.alloy >= 0 && sel.alloy && optVal(v, OPT.alloy) !== sel.alloy) return;
        if (which === 'layer' && OPT.thick >= 0 && sel.thick && optVal(v, OPT.thick) !== sel.thick) return;
        var val = optVal(v, OPT[which]);
        if (val == null || seen[val]) return;
        seen[val] = 1;
        out.push({ value: val, available: v.available, price: v.price });
      });
      return out;
    }
    function findVariant(sel) {
      var match = null;
      PRODUCT.variants.forEach(function (v) {
        if (match) return;
        if (OPT.alloy >= 0 && sel.alloy && optVal(v, OPT.alloy) !== sel.alloy) return;
        if (OPT.thick >= 0 && sel.thick && optVal(v, OPT.thick) !== sel.thick) return;
        if (OPT.layer >= 0 && sel.layer && optVal(v, OPT.layer) !== sel.layer) return;
        match = v;
      });
      return match;
    }
    function firstAvailable() {
      for (var i = 0; i < PRODUCT.variants.length; i++) if (PRODUCT.variants[i].available) return PRODUCT.variants[i];
      return PRODUCT.variants[0];
    }

    /* ---------------- state ---------------- */
    function newId() { return 'ZB-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase(); }
    function emptyArt() { return { type: null, id: null, x: 0, y: 0, s: 1, r2: 0, canvas: null, name: '' }; }
    function defaultState() {
      var v0 = firstAvailable();
      var zones = {};
      ZONES.forEach(function (z) { zones[z] = { text: '', style: null, color: null, ink: null }; });
      zones['1'].text = 'WORLD';
      zones['2'].text = 'CHAMPION';
      var art = {};
      PLATE_KEYS.forEach(function (k) { art[k] = emptyArt(); });
      return {
        v: 3, id: newId(), schema: SCHEMA,
        template: TEMPLATES[0].id, layout: LAYOUTS[0].id,
        finish: FINISHES[0].id, dualPrimary: 'gold', dualSecondary: 'silver', edge: EDGES[0].id, strap: STRAPS[0].id,
        font: FONTS[0].id, ink: INKS[0].id,
        bannerStyle: STYLES[0].id, bannerColor: BANNERS[0].id,
        layers: 1,
        sel: {
          alloy: v0 ? optVal(v0, OPT.alloy) : null,
          thick: v0 ? optVal(v0, OPT.thick) : null,
          layer: v0 ? optVal(v0, OPT.layer) : null
        },
        variant: v0 ? v0.id : null,
        zones: zones, art: art,
        qty: 1, ack: false, step: 'template', plate: 'center', view: 'angle', mode: '3d', done: {}
      };
    }
    var state = defaultState();
    var uploads = {};           // plate -> File
    /* Last upload message, kept per plate so it survives the paintPanel() that
       follows every upload. Without this the note is rebuilt away instantly. */
    var upMsg = null;           // { key, text, bad }
    var sent = {};              // analytics dedupe
    var belt3d = null, three = null, boot3dStarted = false;
    var geom = G.build(state.template, state.layers);
    var busy = false;
    /* The live preview draws at most two tiers. Triple and quadruple stacks stay
       fully selectable — they drive the price, the cart, the spec and production —
       but a four-tier stack cannot be aligned convincingly at preview size, and a
       belt that looks wrong on screen costs more than one that is honestly
       labelled. `previewLayers` is what gets drawn; `state.layers` is what gets
       ordered, and the preview says so out loud whenever the two differ. */
    var PREVIEW_MAX_LAYERS = 2;
    function previewLayers() { return Math.min(clamp(state.layers || 1, 1, 4), PREVIEW_MAX_LAYERS); }
    function rebuildGeom() { geom = G.build(state.template, previewLayers()); }

    /* ---------------- persistence ---------------- */
    function save() {
      try {
        var copy = JSON.parse(JSON.stringify(state, function (k, v) { return k === 'canvas' ? undefined : v; }));
        localStorage.setItem(STORAGE, JSON.stringify(copy));
      } catch (e) { /* private mode */ }
    }
    function restore() {
      try {
        var raw = localStorage.getItem(STORAGE);
        if (!raw) return;
        var s = JSON.parse(raw);
        if (!s || s.v !== 3) return;
        if (!byId(TEMPLATES, s.template)) return;
        ['template', 'layout', 'finish', 'dualPrimary', 'dualSecondary', 'edge', 'strap', 'font', 'ink', 'bannerStyle', 'bannerColor', 'layers', 'sel', 'variant', 'id'].forEach(function (k) {
          if (s[k] !== undefined) state[k] = s[k];
        });
        ZONES.forEach(function (z) {
          if (s.zones && s.zones[z]) state.zones[z] = { text: cleanText(s.zones[z].text || '', z), style: s.zones[z].style, color: s.zones[z].color, ink: s.zones[z].ink };
        });
        PLATE_KEYS.forEach(function (k) {
          var a = s.art && s.art[k];
          if (a && a.type === 'clip' && byId(CLIP, a.id)) state.art[k] = { type: 'clip', id: a.id, x: a.x || 0, y: a.y || 0, s: a.s || 1, r2: a.r2 || 0, canvas: null, name: '' };
        });
        state.layers = clamp(parseInt(state.layers, 10) || 1, 1, 4);
        if (!byId(FINISHES, state.finish)) state.finish = FINISHES[0].id;
        if (!byId(EDGES, state.edge)) state.edge = EDGES[0].id;
        if (!byId(STRAPS, state.strap)) state.strap = STRAPS[0].id;
        if (!byId(LAYOUTS, state.layout)) state.layout = LAYOUTS[0].id;
        rebuildGeom();
      } catch (e) { /* ignore */ }
    }

    /* ---------------- sanitise ---------------- */
    function cleanText(raw, zone) {
      var max = ZONE_MAX[zone] || 18;
      return String(raw || '').toUpperCase().replace(ALLOWED, '').replace(/\s{2,}/g, ' ').slice(0, max);
    }
    function zoneCfg(z) {
      var c = state.zones[z] || {};
      return {
        text: c.text || '',
        style: c.style || state.bannerStyle,
        color: c.color || state.bannerColor,
        ink: c.ink || state.ink
      };
    }

    /* ---------------- pricing ---------------- */
    function variantObj() { return byId(PRODUCT.variants, state.variant) || firstAvailable(); }
    function strapSurcharge() { var s = byId(STRAPS, state.strap); return s && s.surcharge ? s.surcharge * 100 : 0; }
    function unitPrice() { var v = variantObj(); return (v ? v.price : 0) + strapSurcharge(); }

    /* ---------------- analytics (no PII) ---------------- */
    function track(name, payload) {
      var key = name + ':' + JSON.stringify(payload || {});
      if (name !== 'zb_lcb_add_to_cart' && sent[key]) return;
      sent[key] = 1;
      var detail = Object.assign({ schema: SCHEMA, design_id: state.id }, payload || {});
      try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) { }
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, detail));
      if (CFG.debug) console.log('[zb-lcb]', name, detail);
    }

    /* ---------------- fonts ---------------- */
    var ensureFonts = once(function () {
      var fams = FONTS.map(function (f) { return 'family=' + f.gf; }).join('&');
      var l = el('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?' + fams + '&display=swap' });
      document.head.appendChild(l);
      if (document.fonts && document.fonts.ready) return document.fonts.ready;
      return Promise.resolve();
    });

    /* ---------------- artwork canvases (shared by 2D and 3D) ---------------- */
    function clipCanvas(clip, size) {
      var S = size || 512;
      var c = document.createElement('canvas'); c.width = S; c.height = S;
      var x = c.getContext('2d');
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="' + S + '" height="' + S + '">'
        + '<g fill="#ffffff">' + clip.svg + '</g></svg>';
      return new Promise(function (res) {
        var img = new Image();
        img.onload = function () { x.drawImage(img, 0, 0, S, S); res(c); };
        img.onerror = function () { res(c); };
        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
      });
    }

    /* ------------------------------------------------------------------
       LOGO BACKGROUND REMOVAL
       Customers upload logos straight off a phone or a website, and most of
       them arrive as a JPEG on a white card. Engraved on a belt that white
       card shows as a square patch around the artwork, so any upload that is
       not already transparent gets keyed here: the edge colour is sampled,
       the connected run of it flooded out from the border, the cut feathered
       so the edge does not look stamped, and what is left is trimmed and
       re-centred. An image whose border is busy (a photograph, a logo on a
       scene) is left exactly as it came, because guessing there does more
       harm than good.
       ------------------------------------------------------------------ */
    function keyOutBackground(img) {
      var w = img.naturalWidth, h = img.naturalHeight;
      var sc = Math.min(1, 1000 / Math.max(w, h));
      var cw = Math.max(1, Math.round(w * sc)), ch = Math.max(1, Math.round(h * sc));
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var x = c.getContext('2d');
      x.drawImage(img, 0, 0, cw, ch);
      var d;
      try { d = x.getImageData(0, 0, cw, ch); } catch (e) { return { canvas: c, keyed: false }; }
      var p = d.data, n = cw * ch, i;

      /* already transparent? then it is somebody's PNG and we leave it alone */
      var clear = 0;
      for (i = 3; i < p.length; i += 4) if (p[i] < 250) clear++;
      if (clear > n * 0.02) return { canvas: c, keyed: false };

      /* the border ring decides what the background is */
      var ring = [], k;
      function push(px, py) { var o = (py * cw + px) * 4; ring.push([p[o], p[o + 1], p[o + 2]]); }
      for (k = 0; k < cw; k++) { push(k, 0); push(k, ch - 1); }
      for (k = 1; k < ch - 1; k++) { push(0, k); push(cw - 1, k); }
      function med(ch3) { var a = ring.map(function (v) { return v[ch3]; }).sort(function (m, q) { return m - q; }); return a[a.length >> 1]; }
      var kr = med(0), kg = med(1), kb = med(2);
      function dist(r, g, b) { var dr = r - kr, dg = g - kg, db = b - kb; return Math.sqrt(dr * dr + dg * dg + db * db); }
      var T0 = 44, T1 = 96, near = 0;
      for (i = 0; i < ring.length; i++) if (dist(ring[i][0], ring[i][1], ring[i][2]) < T0) near++;
      if (near / ring.length < 0.72) return { canvas: c, keyed: false };

      /* flood the background in from every edge pixel, so a white circle
         inside a letter stays white and only what wraps the logo is cut */
      var seen = new Uint8Array(n), stack = [], px2, py2, o2;
      for (k = 0; k < cw; k++) { stack.push(k); stack.push((ch - 1) * cw + k); }
      for (k = 0; k < ch; k++) { stack.push(k * cw); stack.push(k * cw + cw - 1); }
      while (stack.length) {
        var idx = stack.pop();
        if (idx < 0 || idx >= n || seen[idx]) continue;
        o2 = idx * 4;
        var dd = dist(p[o2], p[o2 + 1], p[o2 + 2]);
        if (dd > T1) continue;
        seen[idx] = 1;
        /* feather: fully clear at the key colour, fading back in towards the art */
        p[o2 + 3] = dd <= T0 ? 0 : Math.round(255 * (dd - T0) / (T1 - T0));
        px2 = idx % cw; py2 = (idx / cw) | 0;
        if (px2 > 0) stack.push(idx - 1);
        if (px2 < cw - 1) stack.push(idx + 1);
        if (py2 > 0) stack.push(idx - cw);
        if (py2 < ch - 1) stack.push(idx + cw);
      }
      var cut = 0;
      for (i = 0; i < n; i++) if (seen[i]) cut++;
      if (cut < n * 0.04) return { canvas: c, keyed: false };
      x.putImageData(d, 0, 0);
      return { canvas: c, keyed: true };
    }

    /* crop to what is actually drawn, so a small logo on a big canvas still
       fills the plate instead of floating in the middle of its own padding */
    /* a canvas as a real PNG file, so the background we removed stays removed
       all the way through to the workshop */
    function canvasBlob(cv) {
      try {
        var parts = cv.toDataURL('image/png').split(',');
        var bin = atob(parts[1]), len = bin.length, arr = new Uint8Array(len), i;
        for (i = 0; i < len; i++) arr[i] = bin.charCodeAt(i);
        return new Blob([arr], { type: 'image/png' });
      } catch (e) { return null; }
    }

    function trimToArt(src) {
      var w = src.width, h = src.height, x = src.getContext('2d'), d;
      try { d = x.getImageData(0, 0, w, h); } catch (e) { return src; }
      var p = d.data, minX = w, minY = h, maxX = -1, maxY = -1, i, px, py;
      for (py = 0; py < h; py++) for (px = 0; px < w; px++) {
        i = (py * w + px) * 4 + 3;
        if (p[i] > 12) { if (px < minX) minX = px; if (px > maxX) maxX = px; if (py < minY) minY = py; if (py > maxY) maxY = py; }
      }
      if (maxX < 0 || (maxX - minX) < 8 || (maxY - minY) < 8) return src;
      var cw = maxX - minX + 1, ch = maxY - minY + 1;
      var out = document.createElement('canvas'); out.width = cw; out.height = ch;
      out.getContext('2d').drawImage(src, minX, minY, cw, ch, 0, 0, cw, ch);
      return out;
    }

    function fileCanvas(file, size) {
      var S = size || 768;
      return new Promise(function (res, rej) {
        var fr = new FileReader();
        fr.onload = function () {
          var img = new Image();
          img.onload = function () {
            /* The old floor was 300 px and it turned away ordinary logo files —
               a 256x256 PNG off a website is a perfectly engravable piece of
               line art. Refuse only what is genuinely unusable; anything
               between minPx and goodPx is accepted with a note that fine
               detail may soften. */
            if (Math.max(img.naturalWidth, img.naturalHeight) < DATA.upload.minPx) { rej(new Error('too small')); return; }
            var ko = keyOutBackground(img);
            var art = ko.keyed ? trimToArt(ko.canvas) : ko.canvas;
            var c = document.createElement('canvas'); c.width = S; c.height = S;
            var x = c.getContext('2d');
            var r = Math.min(S / art.width, S / art.height);
            var w = art.width * r, h = art.height * r;
            x.drawImage(art, (S - w) / 2, (S - h) / 2, w, h);
            res({ canvas: c, w: img.naturalWidth, h: img.naturalHeight, keyed: ko.keyed });
          };
          img.onerror = function () { rej(new Error('decode')); };
          img.src = fr.result;
        };
        fr.onerror = function () { rej(new Error('read')); };
        fr.readAsDataURL(file);
      });
    }
    function refreshArt(plateKey) {
      var a = state.art[plateKey];
      if (!a || !a.type) return Promise.resolve();
      if (a.canvas) return Promise.resolve();
      if (a.type === 'clip') {
        var c = byId(CLIP, a.id);
        if (!c) { state.art[plateKey] = emptyArt(); return Promise.resolve(); }
        return clipCanvas(c).then(function (cv) { a.canvas = cv; });
      }
      if (a.type === 'logo' && uploads[plateKey]) {
        return fileCanvas(uploads[plateKey]).then(function (o) {
          a.canvas = o.canvas; a.px = o.w + '×' + o.h; a.keyed = !!o.keyed;
          a.w = o.w; a.h = o.h;   /* kept as numbers for the size note + thumbnail caption */
        });
      }
      return Promise.resolve();
    }
    function refreshAllArt() { return Promise.all(PLATE_KEYS.map(refreshArt)); }

    /* ---------------- 2D SVG belt (instant paint + fallback) ---------------- */
    function metalsOf(st) {
      if (st.finish === 'dual') {
        var a = byId(DUAL, st.dualPrimary) || DUAL[0];
        var b = byId(DUAL, st.dualSecondary) || DUAL[1] || DUAL[0];
        return { body: a.hex, trim: b.hex, obj: b.hex };
      }
      var f = byId(FINISHES, st.finish) || FINISHES[0];
      return { body: f.body, trim: f.trim || f.body, obj: f.trim || f.body };
    }
    function svgBelt(st, gm, opts) {
      opts = opts || {};
      var g = gm || geom;
      var mt = metalsOf(st);
      var sp = byId(STRAPS, st.strap) || STRAPS[0];
      var font = byId(FONTS, st.font) || FONTS[0];
      var body = mt.body, trim = mt.trim, obj = mt.obj;
      var uid = 'g' + Math.random().toString(36).slice(2, 8);
      var o = [];
      o.push('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + g.W + ' ' + g.H + '" width="100%" role="img" aria-label="' + esc(g.name) + ' championship belt preview">');
      o.push('<defs>');
      o.push('<linearGradient id="' + uid + 'm" x1="0" y1="0" x2="0.22" y2="1">'
        + '<stop offset="0" stop-color="' + shade(body, 0.55) + '"/><stop offset="0.22" stop-color="' + shade(body, 0.14) + '"/>'
        + '<stop offset="0.47" stop-color="' + shade(body, -0.42) + '"/><stop offset="0.60" stop-color="' + shade(body, 0.10) + '"/>'
        + '<stop offset="0.84" stop-color="' + shade(body, -0.20) + '"/><stop offset="1" stop-color="' + shade(body, 0.34) + '"/></linearGradient>');
      o.push('<linearGradient id="' + uid + 'o" x1="0" y1="0" x2="0.22" y2="1">'
        + '<stop offset="0" stop-color="' + shade(obj, 0.58) + '"/><stop offset="0.30" stop-color="' + shade(obj, 0.10) + '"/>'
        + '<stop offset="0.52" stop-color="' + shade(obj, -0.40) + '"/><stop offset="0.74" stop-color="' + shade(obj, 0.06) + '"/>'
        + '<stop offset="1" stop-color="' + shade(obj, 0.40) + '"/></linearGradient>');
      o.push('<linearGradient id="' + uid + 't" x1="0" y1="0" x2="0.2" y2="1">'
        + '<stop offset="0" stop-color="' + shade(trim, 0.42) + '"/><stop offset="0.5" stop-color="' + trim + '"/><stop offset="1" stop-color="' + shade(trim, -0.44) + '"/></linearGradient>');
      o.push('<linearGradient id="' + uid + 's" x1="0" y1="0" x2="0" y2="1">'
        + '<stop offset="0" stop-color="' + shade(sp.hex, 0.30) + '"/><stop offset="0.42" stop-color="' + shade(sp.hex, 0.05) + '"/>'
        + '<stop offset="1" stop-color="' + shade(sp.hex, -0.42) + '"/></linearGradient>');
      o.push('<filter id="' + uid + 'd" x="-14%" y="-14%" width="128%" height="128%">'
        + '<feDropShadow dx="0" dy="7" stdDeviation="9" flood-color="#000" flood-opacity="0.5"/></filter>');
      o.push('<filter id="' + uid + 'ds" x="-14%" y="-14%" width="128%" height="128%">'
        + '<feDropShadow dx="1" dy="3" stdDeviation="2.6" flood-color="#000" flood-opacity="0.55"/></filter>');
      o.push('</defs>');

      /* ---- leather ---- */
      var s = g.strap;
      o.push('<path d="' + s.band.svg() + '" fill="url(#' + uid + 's)" stroke="' + shade(sp.hex, -0.55) + '" stroke-width="3"/>');
      o.push('<path d="' + s.stitch.svg() + '" fill="none" stroke="' + (sp.stitch || '#d9c98a') + '" stroke-width="4" stroke-dasharray="10 9" stroke-linecap="round" opacity="0.9"/>');
      o.push('<path d="' + s.stitch2.svg() + '" fill="none" stroke="' + (sp.stitch || '#d9c98a') + '" stroke-width="2.6" stroke-dasharray="9 10" stroke-linecap="round" opacity="0.55"/>');
      s.eyelets.forEach(function (e) {
        o.push('<circle cx="' + e.x + '" cy="' + e.y + '" r="' + e.r + '" fill="url(#' + uid + 't)"/>');
        o.push('<circle cx="' + e.x + '" cy="' + e.y + '" r="' + (e.r * 0.58) + '" fill="#08080a"/>');
      });
      /* No keeper bar. A gold strip sitting on the leather between the last
         plate and the snap studs is not on any belt we make — it read as a
         stray piece of hardware, and the 3D view never had one. */
      s.snaps.forEach(function (n) {
        o.push('<circle cx="' + n.x + '" cy="' + n.y + '" r="' + n.r + '" fill="url(#' + uid + 't)" stroke="' + shade(trim, -0.5) + '" stroke-width="1.4"/>');
        o.push('<circle cx="' + (n.x - n.r * 0.26) + '" cy="' + (n.y - n.r * 0.3) + '" r="' + (n.r * 0.36) + '" fill="' + shade(trim, 0.55) + '" opacity="0.8"/>');
      });
      o.push('<path d="' + s.tip.svg() + '" fill="url(#' + uid + 't)" stroke="' + shade(trim, -0.45) + '" stroke-width="2"/>');

      /* ---- plates ---- */
      var fieldHex = shade((byId(BANNERS, st.bannerColor) || BANNERS[0]).hex, -0.78);
      var order = ['outerL', 'outerR', 'innerL', 'innerR', 'center'];
      order.forEach(function (key) {
        var pl = g.plates[key];
        pl.tiers.forEach(function (pt, i) {
          o.push('<path d="' + pt.svg() + '" fill="url(#' + uid + (i % 2 ? 'o' : 'm') + ')" stroke="' + shade(trim, -0.45) + '" stroke-width="' + (i ? 1.6 : 2.6) + '"'
            + (i === 0 ? ' filter="url(#' + uid + 'd)"' : ' filter="url(#' + uid + 'ds)"') + '/>');
          o.push('<path d="' + pt.svg() + '" fill="none" stroke="' + shade(trim, 0.5) + '" stroke-width="1.1" opacity="0.55"/>');
        });
        var lastO = pl.tiers[pl.tiers.length - 1];
        var isC = key === 'center';
        var rimP = lastO.scale(pl.box.cx, pl.box.cy, 1 - (isC ? 0.022 : 0.045), 1 - (isC ? 0.022 : 0.045));
        o.push('<path d="' + rimP.svg() + '" fill="none" stroke="url(#' + uid + 't)" stroke-width="3" opacity="0.95"/>');
        /* recessed enamel field */
        if (pl.field) {
          o.push('<path d="' + pl.field.path.svg() + '" fill="' + fieldHex + '" stroke="' + shade(trim, -0.2) + '" stroke-width="3"/>');
        }
        var a = pl.art;
        if (a && a.r > 6) o.push('<circle cx="' + a.cx + '" cy="' + a.cy + '" r="' + (a.r * 1.05) + '" fill="none" stroke="url(#' + uid + 't)" stroke-width="4"/>');
        var layId = isC ? (st.layout || 'crest') : sideLayoutOf(st.layout, key);
        G.layout(layId, a).forEach(function (q) {
          if (q.kind === 'stroke') o.push('<path d="' + q.d + '" fill="none" stroke="url(#' + uid + 'o)" stroke-width="' + q.w + '" stroke-linecap="round" stroke-linejoin="round"/>');
          else o.push('<path d="' + q.d + '" fill="url(#' + uid + 'o)"/>');
        });
      });

      /* ---- artwork ---- */
      PLATE_KEYS.forEach(function (key) {
        var pl = g.plates[key]; if (!pl) return;
        var a = pl.art, art = st.art[key];
        if (!art || !art.type) return;
        var size = a.r * 2 * 0.92 * (art.s || 1);
        var cx = a.cx + (art.x || 0), cy = a.cy + (art.y || 0);
        var tr = 'translate(' + (cx - size / 2) + ' ' + (cy - size / 2) + ') scale(' + (size / 100) + ')';
        if (art.type === 'clip') {
          var c = byId(CLIP, art.id);
          if (c) o.push('<g transform="' + tr + '" fill="url(#' + uid + 'o)">' + c.svg + '</g>');
        } else if (art.canvas) {
          o.push('<image x="' + (cx - size / 2) + '" y="' + (cy - size / 2) + '" width="' + size + '" height="' + size + '" href="' + art.canvas.toDataURL('image/png') + '" preserveAspectRatio="xMidYMid meet"/>');
        }
      });

      /* ---- banners + lettering, always on top ---- */
      Object.keys(g.plates).forEach(function (key) {
        var pl = g.plates[key];
        pl.slots.forEach(function (slot) {
          var cfg = zoneCfgOf(st, slot.id);
          if (!cfg.text) return;
          var col = byId(BANNERS, cfg.color) || BANNERS[0];
          if (G.BANNER_HAS_FILL[cfg.style]) {
            var shp = G.bannerShape(slot, cfg.style);
            if (shp) {
              o.push('<path d="' + shp.svg() + '" fill="' + col.hex + '" stroke="url(#' + uid + 't)" stroke-width="2.4" filter="url(#' + uid + 'ds)"/>');
              o.push('<path d="' + shp.svg() + '" fill="none" stroke="' + shade(col.hex, 0.34) + '" stroke-width="1" opacity="0.5"/>');
            }
          }
          var tp = G.textPath(slot, cfg.style);
          var pid = uid + 'p' + slot.id;
          var inkObj = byId(INKS, cfg.ink);
          var ink = cfg.ink === 'metal' ? trim : (inkObj && inkObj.hex) || '#f3e2b0';
          /* Fit against the real length of the path the letters sit on. A
             glyph that falls off the end of a textPath is not clipped, it is
             simply not drawn — which is how BELTS came out as ELT and MMA as
             M. textLength then guarantees the fit whatever the font metrics
             turn out to be, and is capped at the word's natural width so short
             words are never stretched across the plate. */
          var tpl = pathLen(G.flatten(tp, 4));
          var avail = Math.max(8, tpl - Math.min(10, tpl * 0.08));
          var fs = fitSize(cfg.text, slot, avail);
          var tl = Math.min(avail, cfg.text.length * fs * 0.66);
          o.push('<path id="' + pid + '" d="' + tp.svg() + '" fill="none"/>');
          o.push('<text font-family="' + esc(font.css) + '" font-weight="' + font.weight + '" font-size="' + fs + '" fill="' + ink + '" letter-spacing="1"'
            + ' stroke="' + shade(ink, -0.5) + '" stroke-width="0.55" paint-order="stroke">'
            + '<textPath href="#' + pid + '" startOffset="50%" text-anchor="middle"'
            + ' textLength="' + tl.toFixed(1) + '" lengthAdjust="spacingAndGlyphs">' + esc(cfg.text) + '</textPath></text>');
        });
      });
      o.push('</svg>');
      return o.join('');
    }
    function sideLayoutOf(main, key) {
      var outer = key.indexOf('outer') === 0;
      var m = { crest: ['wreath', 'minimal'], globe: ['wreath', 'minimal'], shield: ['minimal', 'minimal'], starburst: ['starburst', 'minimal'], wreath: ['wreath', 'minimal'], laurelcrown: ['wreath', 'minimal'], wings: ['minimal', 'minimal'], rope: ['rope', 'rope'], chain: ['chain', 'minimal'], gems: ['gems', 'minimal'], fluted: ['fluted', 'minimal'], deco: ['minimal', 'minimal'], minimal: ['minimal', 'minimal'] };
      var e = m[main] || m.minimal;
      return outer ? e[1] : e[0];
    }
    function zoneCfgOf(st, z) {
      var c = (st.zones && st.zones[z]) || {};
      return { text: c.text || '', style: c.style || st.bannerStyle, color: c.color || st.bannerColor, ink: c.ink || st.ink };
    }
    function pathLen(pts) {
      var L = 0, i;
      for (i = 1; i < pts.length; i++) L += Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]);
      return L;
    }
    function fitSize(text, slot, avail) {
      var base = slot.h * 0.78;
      /* 0.66em per uppercase glyph is about right for the display faces used
         here; 0.58 read as "it fits" for words that did not */
      var approx = text.length * base * 0.66;
      return Math.max(8, Math.min(base, base * (avail / Math.max(1, approx))));
    }
    function shade(hex, amt) {
      var h = String(hex || '#888').replace('#', '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      var n = parseInt(h, 16), r = (n >> 16) & 255, g2 = (n >> 8) & 255, b = n & 255;
      function f(v) { return clamp(Math.round(amt >= 0 ? v + (255 - v) * amt : v * (1 + amt)), 0, 255); }
      return '#' + ((1 << 24) + (f(r) << 16) + (f(g2) << 8) + f(b)).toString(16).slice(1);
    }

    /* ---------------- 3D ---------------- */
    function boot3d() {
      if (boot3dStarted) return;
      boot3dStarted = true;
      if (!window.ZB3D || !ZB3D.supported()) { state.mode = '2d'; paint(); return; }
      var host = $('[data-zb-3d]');
      if (!host) { state.mode = '2d'; return; }
      ui.stage.classList.add('is-loading');
      Promise.all([loadScript(THREE_URL), ensureFonts()])
        .then(function () {
          three = window.THREE;
          belt3d = ZB3D.create(three, host);
          if (!belt3d) { state.mode = '2d'; paint(); return; }
          belt3d.setView(state.view);
          return refreshAllArt().then(function () {
            render3d();
            track('zb_lcb_3d_ready', {});
            setTimeout(function () { if (state.step === 'template') buildThumbs(); }, 400);
          });
        })
        .catch(function (e) {
          console.warn('[zb-lcb] 3D unavailable', e);
          state.mode = '2d';
          ui.stage.classList.add('no3d');
          paint();
        })
        .then(function () { ui.stage.classList.remove('is-loading'); });
    }
    var render3d = debounce(function () {
      if (!belt3d) return;
      try { belt3d.build(geom, st3d(), DATA); } catch (e) { console.warn('[zb-lcb] 3D build failed', e); state.mode = '2d'; paint(); }
      /* 190ms, not 60: a full belt rebuild per keystroke made typing a name
         feel like typing through treacle on a phone. The flat SVG under the
         3D still repaints on every keystroke, so the feedback stays instant. */
    }, 190);
    function st3d() {
      var zones = {};
      ZONES.forEach(function (z) { zones[z] = zoneCfg(z); });
      return {
        finish: state.finish, dualPrimary: state.dualPrimary, dualSecondary: state.dualSecondary,
        edge: state.edge, strap: state.strap, layers: state.layers,
        layout: state.layout, font: state.font, ink: state.ink,
        bannerStyle: state.bannerStyle, bannerColor: state.bannerColor,
        zones: zones, art: state.art
      };
    }
    function debounce(fn, ms) {
      var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); };
    }

    /* ---------------- UI shell ---------------- */
    var ui = {};
    function buildShell() {
      root.innerHTML = '';
      ui.status = el('div', { class: 'zb-status', role: 'status', 'aria-live': 'polite' });

      /* preview column */
      ui.flat = el('div', { class: 'zb-flat' });
      ui.three = el('div', { class: 'zb-3d', 'data-zb-3d': '' });
      ui.stage = el('div', { class: 'zb-stage' }, [ui.three, ui.flat]);
      ui.views = el('div', { class: 'zb-views', role: 'group', 'aria-label': 'Preview angle' }, [
        viewBtn('angle', 'Angle'), viewBtn('front', 'Front'), viewBtn('back', 'Back'), viewBtn('tilt', 'Tilt'), viewBtn('spin360', '360° spin')
      ]);
      ui.modeBtn = el('button', {
        type: 'button', class: 'zb-mode', onclick: function () {
          state.mode = state.mode === '3d' ? '2d' : '3d';
          if (state.mode === '3d') boot3d();
          paint();
        }
      });
      ui.zoom = el('div', { class: 'zb-zoom', role: 'group', 'aria-label': 'Zoom' }, [
        el('button', { type: 'button', class: 'zb-zb', text: '\u2212', 'aria-label': 'Zoom out',
          onclick: function () { zoomBy(1 / 1.25); } }),
        el('button', { type: 'button', class: 'zb-zb zb-zb--r', text: 'Reset', 'aria-label': 'Reset zoom',
          onclick: function () { zoomReset(); } }),
        el('button', { type: 'button', class: 'zb-zb', text: '+', 'aria-label': 'Zoom in',
          onclick: function () { zoomBy(1.25); } })
      ]);
      bindFlatZoom();
      ui.layerNote = el('p', { class: 'zb-layernote', hidden: true });
      ui.preview = el('div', { class: 'zb-preview' }, [
        ui.stage,
        el('div', { class: 'zb-stagebar' }, [ui.views, ui.zoom, ui.modeBtn]),
        ui.layerNote,
        el('p', { class: 'zb-stagenote', text: 'Drag the belt to turn it, pinch or scroll to zoom, or hit 360\u00b0 spin to see the full front and back. Once you are zoomed in, dragging slides the belt across so you can go plate to plate up close. The belt stays on screen as you scroll, so every change shows the moment you make it.' })
      ]);

      /* steps */
      ui.nav = el('ol', { class: 'zb-steps', 'aria-label': 'Design steps' });
      ui.panel = el('div', { class: 'zb-panel' });
      ui.back = el('button', { type: 'button', class: 'zb-btn zb-btn--ghost', text: 'Back', onclick: function () { go(-1); } });
      ui.next = el('button', { type: 'button', class: 'zb-btn zb-btn--next', text: 'Next', onclick: function () { go(1); } });
      ui.nav2 = el('div', { class: 'zb-navbtns' }, [ui.back, ui.next]);

      ui.priceVal = el('strong', { class: 'zb-price__v' });
      ui.priceSub = el('span', { class: 'zb-price__s' });
      ui.cta = el('button', { type: 'button', class: 'zb-btn zb-btn--cta', text: 'Add My Custom Belt to Cart', onclick: addToCart });
      ui.bar = el('div', { class: 'zb-bar' }, [
        el('div', { class: 'zb-price' }, [ui.priceVal, ui.priceSub]),
        ui.cta
      ]);

      ui.work = el('div', { class: 'zb-work' }, [ui.nav, ui.panel, ui.nav2]);
      root.appendChild(el('div', { class: 'zb-grid' }, [ui.preview, ui.work]));
      root.appendChild(ui.bar);
      root.appendChild(ui.status);
    }
    /* ---------------- zoom, in whichever view is showing ----------------
       The flat view is the fallback, the print proof and what a customer on a
       slow phone may spend most of their time in, so it gets the same close
       look as the 3D: the same buttons, the same range, and the same rule that
       once you are zoomed in a drag slides the belt rather than doing nothing. */
    var FZ = { z: 1, x: 0, y: 0 }, FZMIN = 1, FZMAX = 3.2;
    function flatApply() {
      var z = FZ.z, f = ui.flat;
      if (z <= 1.0001) { FZ.x = 0; FZ.y = 0; }
      else {
        var sv = f.querySelector('svg');
        var cw = f.clientWidth || 1, ch = f.clientHeight || 1;
        var sw = (sv && sv.clientWidth) || cw, sh = (sv && sv.clientHeight) || ch;
        FZ.x = clamp(FZ.x, -Math.max(0, (sw * z - cw) / 2 / z), Math.max(0, (sw * z - cw) / 2 / z));
        FZ.y = clamp(FZ.y, -Math.max(0, (sh * z - ch) / 2 / z), Math.max(0, (sh * z - ch) / 2 / z));
      }
      f.style.transform = z > 1.0001 ? 'scale(' + z + ') translate(' + FZ.x + 'px,' + FZ.y + 'px)' : '';
      f.style.cursor = z > 1.01 ? 'grab' : '';
      f.style.touchAction = z > 1.01 ? 'none' : 'pan-y';
    }
    function flatZoomTo(z) { FZ.z = clamp(z || 1, FZMIN, FZMAX); flatApply(); }
    function zoomBy(k) {
      if (state.mode === '3d') { if (belt3d) belt3d.zoomBy(k); return; }
      flatZoomTo(FZ.z * (k || 1));
    }
    function zoomReset() {
      if (belt3d) belt3d.zoomTo(1);
      flatZoomTo(1);
    }
    function bindFlatZoom() {
      var f = ui.flat, d = null, pts = {}, pinch = null;
      f.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') {
          pts[e.pointerId] = { x: e.clientX, y: e.clientY };
          if (Object.keys(pts).length === 2) { d = null; pinch = { d: dist(), z: FZ.z }; return; }
        }
        if (FZ.z <= 1.01 || state.mode === '3d') return;
        d = { x: e.clientX, y: e.clientY, px: FZ.x, py: FZ.y };
        f.style.cursor = 'grabbing';
        try { f.setPointerCapture(e.pointerId); } catch (err) { }
      });
      function dist() {
        var k = Object.keys(pts); if (k.length < 2) return 0;
        var a = pts[k[0]], b = pts[k[1]];
        return Math.hypot(a.x - b.x, a.y - b.y);
      }
      f.addEventListener('pointermove', function (e) {
        if (pts[e.pointerId]) { pts[e.pointerId].x = e.clientX; pts[e.pointerId].y = e.clientY; }
        if (pinch) { var dd = dist(); if (dd > 8 && pinch.d > 8) flatZoomTo(pinch.z * (dd / pinch.d)); return; }
        if (!d) return;
        FZ.x = d.px + (e.clientX - d.x) / FZ.z;
        FZ.y = d.py + (e.clientY - d.y) / FZ.z;
        flatApply();
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (k) {
        f.addEventListener(k, function (e) {
          delete pts[e.pointerId];
          if (Object.keys(pts).length < 2) pinch = null;
          d = null; f.style.cursor = FZ.z > 1.01 ? 'grab' : '';
        });
      });
      f.addEventListener('wheel', function (e) {
        if (state.mode === '3d') return;
        if (!e.ctrlKey && Math.abs(e.deltaY) < 4) return;
        e.preventDefault();
        flatZoomTo(FZ.z * Math.pow(0.9986, e.deltaY * (e.deltaMode === 1 ? 16 : 1)));
      }, { passive: false });
    }
    function viewBtn(id, label) {
      return el('button', {
        type: 'button', class: 'zb-view', 'data-view': id, text: label,
        onclick: function () { state.view = id; if (belt3d) belt3d.setView(id); paintViews(); }
      });
    }
    function paintViews() {
      $$('.zb-view', ui.views).forEach(function (b) {
        var on = b.getAttribute('data-view') === state.view;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      ui.views.hidden = state.mode !== '3d';
      ui.zoom.hidden = state.mode !== '3d';
      /* the live view is capped at two layers, so say so plainly rather than
         letting a quadruple-layer order silently look like a double */
      var L = clamp(state.layers || 1, 1, 4);
      var over = L > PREVIEW_MAX_LAYERS;
      ui.layerNote.hidden = !over;
      if (over) {
        ui.layerNote.textContent = 'You have chosen a ' + (L === 3 ? 'triple' : 'quadruple')
          + '-layer belt. The preview shows the artwork at double-layer depth so every plate edge stays crisp \u2014 your belt is still made with all '
          + L + ' layers, and the extra tiers are listed on your order and on the mockup PDF.';
      }
    }
    function say(msg) { ui.status.textContent = msg; }

    /* ---------------- painting ---------------- */
    /* Everything that can change what the belt LOOKS like, as one string.
       paint() runs for step changes, price changes and nav changes too, and
       re-extruding the whole belt for those cost a phone ~1.7s of jank per tap
       for a picture that did not change. */
    var lastBeltSig = null, sigSeq = 0;
    function objSig(o) {
      if (!o) return '';
      var k = Object.keys(o).sort(), s = '', i, v;
      for (i = 0; i < k.length; i++) {
        if (k[i] === '__zbid') continue;
        v = o[k[i]];
        if (v && typeof v === 'object') { if (!v.__zbid) { try { v.__zbid = ++sigSeq; } catch (e) { return 'x' + (++sigSeq); } } s += k[i] + '#' + v.__zbid + ','; }
        else s += k[i] + '=' + v + ',';
      }
      return s;
    }
    function beltSig() {
      var s = [state.mode, state.template, state.layers, state.finish, state.dualPrimary,
        state.dualSecondary, state.edge, state.strap, state.layout, state.font, state.ink,
        state.bannerStyle, state.bannerColor].join('/');
      ZONES.forEach(function (z) { s += '|' + objSig(state.zones[z]); });
      PLATE_KEYS.forEach(function (k) { s += '~' + objSig(state.art[k]); });
      return s;
    }
    function paint() {
      ui.stage.classList.toggle('is-3d', state.mode === '3d');
      ui.modeBtn.textContent = state.mode === '3d' ? 'Show flat view' : 'Show 3D view';
      ui.modeBtn.setAttribute('aria-pressed', state.mode === '3d' ? 'true' : 'false');
      var sig = beltSig(), beltChanged = sig !== lastBeltSig;
      lastBeltSig = sig;
      if (beltChanged) { ui.flat.innerHTML = svgBelt(state, geom); flatApply(); }
      paintViews();
      if (state.mode === '3d') { boot3d(); if (beltChanged) render3d(); }
      paintNav();
      paintPrice();
      save();
    }
    function paintPrice() {
      var v = variantObj();
      ui.priceVal.textContent = money(unitPrice());
      var bits = [];
      if (v && v.title && v.title !== 'Default Title') bits.push(v.title);
      if (strapSurcharge()) bits.push('incl. $45 textured strap');
      ui.priceSub.textContent = bits.join(' · ');
      ui.cta.disabled = !v || !v.available;
      if (v && !v.available) ui.priceSub.textContent = 'That build is out of stock — pick another thickness.';
    }
    function paintNav() {
      ui.nav.innerHTML = '';
      STEPS.forEach(function (id, i) {
        var on = id === state.step;
        var li = el('li', { class: 'zb-step' + (on ? ' is-on' : '') + (state.done[id] ? ' is-done' : '') }, [
          el('button', {
            type: 'button', 'aria-current': on ? 'step' : null,
            onclick: function () { state.step = id; paintPanel(); paintNav(); }
          }, [
            el('span', { class: 'zb-step__n', text: String(i + 1) }),
            el('span', { class: 'zb-step__t', text: STEP_TITLE[id] })
          ])
        ]);
        ui.nav.appendChild(li);
      });
      var i = STEPS.indexOf(state.step);
      ui.back.disabled = i <= 0;
      ui.next.hidden = i >= STEPS.length - 1;
      /* On the last step there is no STEPS[i+1], and the old line happily
         wrote "Next: undefined" into the button. It was only ever meant to be
         invisible there, which is one CSS rule away from being read out or
         shown. Leave the label alone once there is no next step. */
      if (!ui.next.hidden) {
        ui.next.textContent = i === STEPS.length - 2
          ? 'Review my belt'
          : 'Next: ' + STEP_TITLE[STEPS[i + 1]];
      }
    }
    function go(d) {
      var i = clamp(STEPS.indexOf(state.step) + d, 0, STEPS.length - 1);
      state.done[state.step] = true;
      state.step = STEPS[i];
      paintPanel(); paintNav(); save();
      track('zb_lcb_step', { step: state.step });
      ui.panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    /* ---------------- generic controls ---------------- */
    function section(title, hint, kids) {
      return el('fieldset', { class: 'zb-fs' }, [el('legend', { text: title })]
        .concat(hint ? [el('p', { class: 'zb-hint', text: hint })] : [])
        .concat(kids || []));
    }
    function choiceGrid(name, items, current, onPick, opts) {
      opts = opts || {};
      var grid = el('div', { class: 'zb-grid-opts ' + (opts.cls || ''), role: 'radiogroup', 'aria-label': opts.label || name });
      items.forEach(function (it) {
        var on = String(it.id) === String(current);
        var kids = [];
        if (opts.swatch) kids.push(el('span', { class: 'zb-sw', style: 'background:' + (it.swatch || it.hex || '#888') }));
        if (opts.thumb) { var th = el('span', { class: 'zb-thumb', html: opts.thumb(it) }); th.setAttribute('data-thumb', String(it.id)); kids.push(th); }
        kids.push(el('span', { class: 'zb-opt__n', text: it.name }));
        if (it.desc && !opts.tight) kids.push(el('span', { class: 'zb-opt__d', text: it.desc }));
        if (it.surcharge) kids.push(el('span', { class: 'zb-opt__p', text: '+$' + it.surcharge }));
        var b = el('button', {
          type: 'button', role: 'radio', 'aria-checked': on ? 'true' : 'false',
          class: 'zb-opt' + (on ? ' is-on' : ''),
          onclick: function () { onPick(it); }
        }, kids);
        grid.appendChild(b);
      });
      return grid;
    }
    function pillRow(items, current, onPick, label) {
      var row = el('div', { class: 'zb-pills', role: 'radiogroup', 'aria-label': label || '' });
      items.forEach(function (it) {
        var on = String(it.id) === String(current);
        row.appendChild(el('button', {
          type: 'button', role: 'radio', 'aria-checked': on ? 'true' : 'false',
          class: 'zb-pill' + (on ? ' is-on' : ''), text: it.name,
          onclick: function () { onPick(it); }
        }));
      });
      return row;
    }
    /* ---------------- belt-shape thumbnails ----------------
       Rendered by the same WebGL pipeline as the main preview, on a small offscreen
       context, so the 12 shape swatches are photographic rather than flat vectors.
       Falls back to the SVG belt while they are being produced (or with no WebGL). */
    var THUMB = { cache: {}, key: '', busy: false };
    function thumbState(tplId) {
      var st = {
        finish: state.finish, dualPrimary: state.dualPrimary, dualSecondary: state.dualSecondary,
        edge: state.edge, strap: state.strap, layers: state.layers, layout: state.layout,
        font: state.font, ink: state.ink, bannerStyle: state.bannerStyle, bannerColor: state.bannerColor,
        zones: {}, art: {}
      };
      ZONES.forEach(function (z) { st.zones[z] = { text: '' }; });
      PLATE_KEYS.forEach(function (k) { st.art[k] = { type: null }; });
      return st;
    }
    function thumbKey() {
      return [state.finish, state.dualPrimary, state.dualSecondary, state.edge, state.strap, state.layers, state.layout, state.bannerColor].join('|');
    }
    function thumbSvg(tplId) {
      var k = thumbKey();
      if (THUMB.key === k && THUMB.cache[tplId]) {
        return '<img src="' + THUMB.cache[tplId] + '" alt="" width="520" height="170" loading="lazy" decoding="async">';
      }
      return svgBelt(thumbState(tplId), G.build(tplId, previewLayers()));
    }
    function buildThumbs() {
      /* Rendered on the main belt renderer, never a second WebGL context — a second
         context is what makes mobile browsers drop the first one. The 12 shapes are
         captured in one pass, then the customer's own design is rebuilt. */
      if (THUMB.busy || !belt3d || !three) return;
      var k = thumbKey();
      if (THUMB.key === k && Object.keys(THUMB.cache).length >= TEMPLATES.length) return;
      THUMB.busy = true;
      belt3d.suspend();
      var next = {}, i = 0;
      /* One shape per idle slice. Twelve belt builds back to back is the single
         heaviest thing this page does, and it lands right when the customer is
         starting to tap — idle slices let their taps go first. */
      var slice = window.requestIdleCallback
        ? function (fn) { window.requestIdleCallback(fn, { timeout: 900 }); }
        : function (fn) { setTimeout(fn, 0); };
      function step() {
        /* they moved on: the thumbnails are no longer worth the main thread */
        if (i && state.step !== 'template') {
          THUMB.busy = false;
          try { belt3d.build(geom, st3d(), DATA); } catch (e) { /* restored on next paint */ }
          belt3d.resume();
          return;
        }
        if (i >= TEMPLATES.length) {
          THUMB.cache = next; THUMB.key = k; THUMB.busy = false;
          try { belt3d.build(geom, st3d(), DATA); } catch (e) { /* restored on next paint */ }
          belt3d.resume();
          paintThumbs();
          return;
        }
        var t = TEMPLATES[i++];
        try {
          belt3d.build(G.build(t.id, previewLayers()), thumbState(t.id), DATA, true);
          var u = belt3d.capture(460, 150, 'front', 'image/jpeg', 0.84);
          if (u) next[t.id] = u;
        } catch (e) { /* skip this shape */ }
        slice(step);
      }
      slice(step);
    }
    function paintThumbs() {
      $$('.zb-thumb[data-thumb]', ui.panel).forEach(function (n) {
        var id = n.getAttribute('data-thumb');
        if (THUMB.cache[id]) n.innerHTML = '<img src="' + THUMB.cache[id] + '" alt="" width="520" height="170" loading="lazy" decoding="async">';
      });
    }

    /* ---------------- step panels ---------------- */
    function paintPanel() {
      ui.panel.innerHTML = '';
      /* h2, not h3: this is a top-level section of the page, and the only
         heading above it is the h1. An h1 -> h3 jump is a heading-level skip
         that screen readers and search engines both read as a broken outline. */
      ui.panel.appendChild(el('h2', { class: 'zb-panel__h', text: STEP_TITLE[state.step] }));
      ui.panel.appendChild(el('p', { class: 'zb-panel__p', text: STEP_HINT[state.step] }));
      var fn = PANELS[state.step];
      if (fn) fn(ui.panel);
    }

    var PANELS = {};

    PANELS.template = function (p) {
      p.appendChild(choiceGrid('template', TEMPLATES, state.template, function (t) {
        state.template = t.id;
        rebuildGeom();
        paint(); paintPanel();
        track('zb_lcb_option', { field: 'template', value: t.id });
      }, { cls: 'zb-grid-opts--tpl', label: 'Belt shape', thumb: function (t) { return thumbSvg(t.id); } }));
      buildThumbs();
    };

    PANELS.metal = function (p) {
      var metalKids = [choiceGrid('finish', FINISHES, state.finish, function (f) {
        state.finish = f.id; paint(); paintPanel();
        track('zb_lcb_option', { field: 'finish', value: f.id });
      }, { swatch: true, tight: true, label: 'Metal finish' })];
      if (state.finish === 'dual') {
        var dualBox = el('div', { class: 'zb-dual' }, [
          el('p', { class: 'zb-dual__h', text: 'Dual plating — choose your two metals' }),
          el('p', { class: 'zb-dual__p', text: 'The primary metal plates the belt plates themselves. The secondary metal plates every raised object on them — the crest, wreath, rims, lettering and hardware. Two solid metals, never a gradient.' }),
          el('div', { class: 'zb-dual__g' }, [
            el('div', {}, [
              el('span', { class: 'zb-dual__l', text: 'Primary — the plates' }),
              pillRow(DUAL, state.dualPrimary, function (m) {
                state.dualPrimary = m.id;
                if (state.dualSecondary === m.id) state.dualSecondary = m.id === 'gold' ? 'silver' : 'gold';
                paint(); paintPanel();
                track('zb_lcb_option', { field: 'dualPrimary', value: m.id });
              }, 'Primary plating metal')
            ]),
            el('div', {}, [
              el('span', { class: 'zb-dual__l', text: 'Secondary — the raised objects' }),
              pillRow(DUAL, state.dualSecondary, function (m) {
                state.dualSecondary = m.id;
                if (state.dualPrimary === m.id) state.dualPrimary = m.id === 'gold' ? 'silver' : 'gold';
                paint(); paintPanel();
                track('zb_lcb_option', { field: 'dualSecondary', value: m.id });
              }, 'Secondary plating metal')
            ])
          ])
        ]);
        metalKids.push(dualBox);
      }
      p.appendChild(section('Metal finish', 'Three platings: gold, nickel, or dual plating with two metals.', metalKids));

      p.appendChild(section('Surface', 'How the metal is finished after plating.',
        [choiceGrid('edge', EDGES, state.edge, function (e) {
          state.edge = e.id; paint(); paintPanel();
          track('zb_lcb_option', { field: 'edge', value: e.id });
        }, { tight: false, label: 'Surface finish' })]));

      /* alloy / thickness / layers — the priced options */
      var alloys = valuesFor('alloy', {}).map(function (o) { return { id: o.value, name: o.value, desc: 'from ' + money(o.price), available: o.available }; });
      p.appendChild(section('Plate alloy', 'Sets the base price of the belt.',
        [choiceGrid('alloy', alloys, state.sel.alloy, function (o) { setOpt('alloy', o.id); }, { label: 'Plate alloy' })]));

      if (OPT.thick >= 0) {
        var thicks = valuesFor('thick', state.sel).map(function (o) { return { id: o.value, name: o.value, desc: money(o.price), available: o.available }; });
        p.appendChild(section('Plate thickness', 'Thicker plates carry deeper relief and more weight.',
          [choiceGrid('thick', thicks, state.sel.thick, function (o) { setOpt('thick', o.id); }, { label: 'Plate thickness', tight: true })]));
      }

      p.appendChild(section('Plate layers', 'Stacked tiers give the front plate real depth. Turn the belt to see it.',
        [choiceGrid('layers', LAYERS, state.layers, function (l) {
          state.layers = l.id;
          rebuildGeom();
          if (OPT.layer >= 0) {
            var want = null;
            valuesFor('layer', state.sel).forEach(function (o) { if (!want && new RegExp('^' + l.id + '\\b|' + l.name, 'i').test(o.value)) want = o.value; });
            if (want) { state.sel.layer = want; syncVariant(); }
          }
          paint(); paintPanel();
          track('zb_lcb_option', { field: 'layers', value: l.id });
        }, { label: 'Plate layers' })]));
    };

    function setOpt(which, value) {
      state.sel[which] = value;
      /* repair downstream selections that no longer exist */
      if (which === 'alloy' && OPT.thick >= 0) {
        var t = valuesFor('thick', state.sel);
        if (!t.some(function (o) { return o.value === state.sel.thick; })) state.sel.thick = t.length ? t[0].value : null;
      }
      if (OPT.layer >= 0) {
        var l = valuesFor('layer', state.sel);
        if (!l.some(function (o) { return o.value === state.sel.layer; })) state.sel.layer = l.length ? l[0].value : null;
      }
      syncVariant();
      paint(); paintPanel();
      track('zb_lcb_option', { field: which, value: value });
    }
    function syncVariant() {
      var v = findVariant(state.sel);
      if (v) state.variant = v.id;
    }

    PANELS.strap = function (p) {
      var plain = STRAPS.filter(function (s) { return !s.surcharge; });
      var tex = STRAPS.filter(function (s) { return s.surcharge; });
      p.appendChild(section('Leather colour', 'Full-grain leather, hand-stitched.',
        [choiceGrid('strap', plain, state.strap, pickStrap, { swatch: true, tight: true, label: 'Leather colour', cls: 'zb-grid-opts--sw' })]));
      if (tex.length) {
        p.appendChild(section('Patterned hides — add $45 each', 'Patterns, not embossing.',
          [
            el('p', { class: 'zb-note zb-note--pat', html: '<strong>These are patterns, not emboss.</strong> Each one is printed and pressed onto our full-grain leather as a surface pattern &mdash; there is no embossed relief and no exotic skin. <strong>Every patterned hide adds $45</strong> to the price shown below, and appears on the 3D belt the moment you pick it.' }),
            choiceGrid('strap', tex, state.strap, pickStrap, { swatch: true, tight: true, label: 'Patterned hides', cls: 'zb-grid-opts--sw' })
          ]));
      }
      function pickStrap(s) {
        state.strap = s.id; paint(); paintPanel();
        track('zb_lcb_option', { field: 'strap', value: s.id, textured: !!s.surcharge });
      }
    };

    PANELS.design = function (p) {
      p.appendChild(choiceGrid('layout', LAYOUTS, state.layout, function (l) {
        state.layout = l.id; paint(); paintPanel();
        track('zb_lcb_option', { field: 'layout', value: l.id });
      }, { label: 'Front-plate layout' }));
    };

    PANELS.banner = function (p) {
      p.appendChild(section('Nameplate style', 'Applies to every plate unless you override it in step 7.',
        [choiceGrid('bannerStyle', STYLES, state.bannerStyle, function (s) {
          state.bannerStyle = s.id; paint(); paintPanel();
          track('zb_lcb_option', { field: 'bannerStyle', value: s.id });
        }, { label: 'Nameplate style' })]));
      p.appendChild(section('Enamel colour', 'Ignored on the engraved style.',
        [choiceGrid('bannerColor', BANNERS, state.bannerColor, function (b) {
          state.bannerColor = b.id; paint(); paintPanel();
          track('zb_lcb_option', { field: 'bannerColor', value: b.id });
        }, { swatch: true, tight: true, label: 'Enamel colour', cls: 'zb-grid-opts--sw' })]));
    };

    PANELS.text = function (p) {
      p.appendChild(section('Typeface', null,
        [pillRow(FONTS, state.font, function (f) {
          state.font = f.id; ensureFonts().then(function () { paint(); }); paint(); paintPanel();
          track('zb_lcb_option', { field: 'font', value: f.id });
        }, 'Typeface')]));
      p.appendChild(section('Lettering finish', null,
        [pillRow(INKS, state.ink, function (i) {
          state.ink = i.id; paint(); paintPanel();
          track('zb_lcb_option', { field: 'ink', value: i.id });
        }, 'Lettering finish')]));

      var wrap = el('div', { class: 'zb-fields' });
      ZONES.forEach(function (z) {
        var max = ZONE_MAX[z] || 18;
        var id = 'zb-z-' + z;
        var inp = el('input', {
          type: 'text', id: id, class: 'zb-input', maxlength: String(max),
          value: state.zones[z].text, autocomplete: 'off', spellcheck: 'false',
          'aria-describedby': id + '-c',
          oninput: function () {
            var v = cleanText(inp.value, z);
            if (v !== inp.value) inp.value = v;
            state.zones[z].text = v;
            count.textContent = v.length + ' / ' + max;
            paint();
          },
          onblur: function () { track('zb_lcb_text', { zone: z, filled: !!state.zones[z].text, len: state.zones[z].text.length }); }
        });
        var count = el('span', { class: 'zb-count', id: id + '-c', text: state.zones[z].text.length + ' / ' + max });
        wrap.appendChild(el('div', { class: 'zb-field' }, [
          el('label', { for: id, text: ZONE_LABEL[z] }),
          inp, count
        ]));
      });
      p.appendChild(section('Your lines', 'Capitals only. Letters, numbers and . , \' & - # ! / : ( ) + are allowed.', [wrap]));
    };

    PANELS.plates = function (p) {
      var tabs = el('div', { class: 'zb-tabs', role: 'tablist', 'aria-label': 'Plates' });
      PLATES.forEach(function (pl) {
        var on = pl.id === state.plate;
        tabs.appendChild(el('button', {
          type: 'button', role: 'tab', 'aria-selected': on ? 'true' : 'false',
          class: 'zb-tab' + (on ? ' is-on' : ''), text: pl.name,
          onclick: function () { state.plate = pl.id; paintPanel(); }
        }));
      });
      p.appendChild(tabs);

      var key = state.plate;
      var body = el('div', { class: 'zb-tabbody', role: 'tabpanel' });
      p.appendChild(body);

      /* ---- artwork ---- */
      var art = state.art[key];
      var catSel = el('select', {
        class: 'zb-select', 'aria-label': 'Clip art category',
        onchange: function () { renderClips(catSel.value); }
      }, CATS.map(function (c) { return el('option', { value: c.id, text: c.name }); }));
      var clipWrap = el('div', { class: 'zb-clips', role: 'radiogroup', 'aria-label': 'Clip art' });
      var search = el('input', {
        type: 'search', class: 'zb-input', placeholder: 'Search artwork…', 'aria-label': 'Search artwork',
        oninput: function () { renderClips(catSel.value, search.value); }
      });
      function renderClips(cat, q) {
        clipWrap.innerHTML = '';
        var term = (q || '').trim().toLowerCase();
        CLIP.filter(function (c) {
          if (term) return (c.name + ' ' + (c.kw || '')).toLowerCase().indexOf(term) > -1;
          return c.cat === cat;
        }).slice(0, 60).forEach(function (c) {
          var on = art.type === 'clip' && art.id === c.id;
          clipWrap.appendChild(el('button', {
            type: 'button', role: 'radio', 'aria-checked': on ? 'true' : 'false', title: c.name,
            class: 'zb-clip' + (on ? ' is-on' : ''),
            onclick: function () { chooseClip(c); }
          }, [
            el('span', { class: 'zb-clip__i', html: '<svg viewBox="0 0 100 100" aria-hidden="true" fill="currentColor">' + c.svg + '</svg>' }),
            el('span', { class: 'zb-clip__n', text: c.name })
          ]));
        });
        if (!clipWrap.children.length) clipWrap.appendChild(el('p', { class: 'zb-hint', text: 'No artwork matches that.' }));
      }
      function chooseClip(c) {
        state.art[key] = { type: 'clip', id: c.id, x: 0, y: 0, s: 1, r2: 0, canvas: null, name: c.name };
        delete uploads[key];
        refreshArt(key).then(function () { paint(); paintPanel(); });
        track('zb_lcb_art', { plate: key, kind: 'clip', id: c.id });
      }

      /* Every upload message used to go only to .zb-status, which is a 1x1
         clipped screen-reader live region. So when a file was rejected the
         customer saw nothing at all happen — the box just went blank — and
         reported that the page "is not letting me upload". Messages now go to
         BOTH: the live region for screen readers, and a note they can see. */
      function sayUp(msg, bad) {
        say(msg);
        upMsg = { key: key, text: msg, bad: !!bad };
      }

      /* The customer's own words were that the file "doesn't show up in the
         upload box, it just stays blank" — there was never a preview there, so
         a successful upload looked the same as a failed one. This puts their
         artwork in the box, at the size it will be engraved. */
      function upThumb(k) {
        var a = state.art[k];
        if (!a || a.type !== 'logo' || !a.canvas) return el('span', { class: 'zb-up-noimg' });
        var im = el('img', { class: 'zb-upthumb__i', alt: 'Your uploaded artwork, ' + (a.name || 'logo') });
        try { im.src = a.canvas.toDataURL('image/png'); } catch (e) { return el('span', { class: 'zb-up-noimg' }); }
        return el('div', { class: 'zb-upthumb' }, [
          im,
          el('span', { class: 'zb-upthumb__n', text: (a.name || 'your logo') + (a.w ? ' · ' + a.w + '×' + a.h + ' px' : '') })
        ]);
      }
      function upNote(k) {
        if (!upMsg || upMsg.key !== k) return el('span', { class: 'zb-up-nonote' });
        return el('p', {
          class: 'zb-upnote' + (upMsg.bad ? ' is-bad' : ' is-ok'),
          role: 'status',
          text: upMsg.text
        });
      }

      var fileIn = el('input', {
        /* image/*, not a three-type allow-list: the old accept greyed out HEIC
           photos straight off an iPhone, and SVG, GIF, AVIF and BMP logos, so
           those customers could not even pick their file. Anything the browser
           can decode works here — it is rasterised onto a canvas either way. */
        type: 'file', class: 'zb-file', accept: 'image/*',
        id: 'zb-up-' + key,
        onchange: function () {
          var f = fileIn.files && fileIn.files[0];
          if (!f) return;
          if (f.size > DATA.upload.maxBytes) {
            sayUp('That file is ' + Math.round(f.size / 1048576) + ' MB — the limit is 10 MB. Please upload a smaller version.', 1);
            fileIn.value = ''; paintPanel(); return;
          }
          uploads[key] = f;
          state.art[key] = { type: 'logo', id: null, x: 0, y: 0, s: 1, r2: 0, canvas: null, name: f.name.slice(0, 60) };
          refreshArt(key).then(function () {
            var a = state.art[key] || {};
            var msg = 'Added ' + f.name.slice(0, 40) + ' to the ' + (byId(PLATES, key) || {}).name + '.';
            if (a.keyed) msg += ' It arrived on a solid background, so we took the background out — only the artwork will be engraved.';
            /* A small logo still engraves fine as line art; it just cannot hold
               fine detail. Say so instead of refusing the file. */
            if (a.w && a.h && Math.max(a.w, a.h) < DATA.upload.goodPx) {
              msg += ' It is only ' + a.w + '×' + a.h + ' px, so fine detail may soften — a larger copy will engrave sharper.';
            }
            sayUp(msg);
            paint(); paintPanel();
            track('zb_lcb_art', { plate: key, kind: 'logo', bytes: f.size });
          }).catch(function (err) {
            var why = err && err.message;
            sayUp(why === 'too small'
              ? 'That image is too small to engrave — it needs to be at least ' + DATA.upload.minPx + ' px on its longest side.'
              : (/\.(heic|heif)$/i.test(f.name)
                ? 'This browser cannot open iPhone HEIC photos. On your iPhone: Settings › Camera › Formats › Most Compatible, or open the photo, tap Share and choose a JPEG copy.'
                : 'We could not read that image file. Please try a PNG, JPG or WebP version of it.'), 1);
            state.art[key] = emptyArt(); delete uploads[key]; fileIn.value = ''; paintPanel();
          });
        }
      });

      body.appendChild(section('Artwork on this plate', 'Pick from 72 original Zees Belts symbols, or upload your own logo.', [
        el('div', { class: 'zb-row' }, [catSel, search]),
        clipWrap,
        el('div', { class: 'zb-upload' }, [
          el('label', { class: 'zb-btn zb-btn--ghost', for: 'zb-up-' + key, text: 'Upload your logo' }),
          fileIn,
          upThumb(key),
          upNote(key),
          el('p', { class: 'zb-hint', text: 'PNG, JPG, WebP or a photo from your phone, up to 10 MB. If your logo comes on a white or coloured background we take the background out for you automatically, so only the artwork is engraved. We keep a copy with your order.' })
        ])
      ]));

      if (art.type) {
        var nudge = el('div', { class: 'zb-nudge' }, [
          slider('Size', 60, 140, Math.round((art.s || 1) * 100), function (v) { art.s = v / 100; paint(); }),
          slider('Up / down', -40, 40, art.y || 0, function (v) { art.y = v; paint(); }),
          slider('Left / right', -40, 40, art.x || 0, function (v) { art.x = v; paint(); }),
          slider('Rotate', -30, 30, art.r2 || 0, function (v) { art.r2 = v; paint(); })
        ]);
        body.appendChild(section('Position ' + (art.name || 'artwork'), null, [
          nudge,
          el('div', { class: 'zb-row' }, [
            el('button', { type: 'button', class: 'zb-btn zb-btn--ghost', text: 'Remove artwork', onclick: function () { state.art[key] = emptyArt(); delete uploads[key]; paint(); paintPanel(); } }),
            el('button', { type: 'button', class: 'zb-btn zb-btn--ghost', text: 'Copy to all plates', onclick: copyArt })
          ])
        ]));
      }

      /* ---- per-plate lettering + nameplate override ---- */
      var plate = byId(PLATES, key);
      var fields = el('div', { class: 'zb-fields' });
      plate.zones.forEach(function (z) {
        var max = ZONE_MAX[z] || 18, id = 'zb-pz-' + z;
        var inp = el('input', {
          type: 'text', id: id, class: 'zb-input', maxlength: String(max), value: state.zones[z].text,
          oninput: function () { var v = cleanText(inp.value, z); if (v !== inp.value) inp.value = v; state.zones[z].text = v; c.textContent = v.length + ' / ' + max; paint(); }
        });
        var c = el('span', { class: 'zb-count', text: state.zones[z].text.length + ' / ' + max });
        fields.appendChild(el('div', { class: 'zb-field' }, [el('label', { for: id, text: ZONE_LABEL[z] }), inp, c]));
      });
      var zc = state.zones[plate.zones[0]];
      body.appendChild(section('Lettering on this plate', null, [
        fields,
        el('p', { class: 'zb-hint', text: 'Nameplate style for this plate' }),
        pillRow([{ id: '', name: 'Match the belt' }].concat(STYLES), zc.style || '', function (s) {
          plate.zones.forEach(function (z) { state.zones[z].style = s.id || null; });
          paint(); paintPanel();
        }, 'Nameplate style for this plate'),
        el('p', { class: 'zb-hint', text: 'Enamel colour for this plate' }),
        pillRow([{ id: '', name: 'Match the belt' }].concat(BANNERS), zc.color || '', function (b) {
          plate.zones.forEach(function (z) { state.zones[z].color = b.id || null; });
          paint(); paintPanel();
        }, 'Enamel colour for this plate')
      ]));

      renderClips(CATS[0].id);

      function copyArt() {
        var src = state.art[key];
        PLATE_KEYS.forEach(function (k) {
          if (k === key) return;
          state.art[k] = { type: src.type, id: src.id, x: src.x, y: src.y, s: src.s, r2: src.r2, canvas: null, name: src.name };
          if (src.type === 'logo' && uploads[key]) uploads[k] = uploads[key];
        });
        refreshAllArt().then(function () { say('Artwork copied to all five plates.'); paint(); paintPanel(); });
      }
    };

    function slider(label, min, max, val, onChange) {
      var out = el('output', { text: String(val) });
      var r = el('input', {
        type: 'range', min: String(min), max: String(max), value: String(val), class: 'zb-range',
        'aria-label': label,
        oninput: function () { out.textContent = r.value; onChange(parseInt(r.value, 10)); }
      });
      return el('div', { class: 'zb-slider' }, [el('span', { class: 'zb-slider__l', text: label }), r, out]);
    }

    /* ---------------- summary ---------------- */
    function nameOf(arr, id, fallback) { var o = byId(arr, id); return o ? o.name : (fallback || id || '—'); }
    function summaryRows() {
      var rows = [];
      var v = variantObj();
      rows.push(['Belt shape', nameOf(TEMPLATES, state.template)]);
      rows.push(['Build', (v && v.title && v.title !== 'Default Title' ? v.title : 'Standard')]);
      rows.push(['Plate layers', nameOf(LAYERS, state.layers)]);
      rows.push(['Metal finish', state.finish === 'dual'
        ? ('Dual plating — ' + nameOf(DUAL, state.dualPrimary) + ' plates / ' + nameOf(DUAL, state.dualSecondary) + ' raised objects')
        : nameOf(FINISHES, state.finish)]);
      rows.push(['Surface', nameOf(EDGES, state.edge)]);
      var sp = byId(STRAPS, state.strap);
      rows.push(['Strap', sp ? sp.name + (sp.surcharge ? ' (textured, +$' + sp.surcharge + ')' : '') : '—']);
      rows.push(['Front-plate layout', nameOf(LAYOUTS, state.layout)]);
      rows.push(['Nameplate style', nameOf(STYLES, state.bannerStyle)]);
      rows.push(['Enamel colour', nameOf(BANNERS, state.bannerColor)]);
      rows.push(['Typeface', nameOf(FONTS, state.font)]);
      rows.push(['Lettering finish', nameOf(INKS, state.ink)]);
      ZONES.forEach(function (z) {
        if (state.zones[z].text) rows.push([ZONE_LABEL[z], state.zones[z].text]);
      });
      PLATE_KEYS.forEach(function (k) {
        var a = state.art[k];
        if (!a || !a.type) return;
        var pl = byId(PLATES, k);
        rows.push([pl.name + ' artwork', a.type === 'clip' ? (nameOf(CLIP, a.id) + ' (Zees Belts art)') : ('Customer upload — ' + (a.name || 'logo'))]);
      });
      return rows;
    }
    function summaryText() {
      return summaryRows().map(function (r) { return r[0] + ': ' + r[1]; }).join(' | ');
    }

    PANELS.review = function (p) {
      var tbl = el('table', { class: 'zb-sum' }, [
        el('tbody', {}, summaryRows().map(function (r) {
          return el('tr', {}, [el('th', { scope: 'row', text: r[0] }), el('td', { text: r[1] })]);
        }))
      ]);
      p.appendChild(section('Your configuration', 'Design ID ' + state.id + ' — this travels with your order.', [tbl]));

      var pdfBtn = el('button', {
        type: 'button', class: 'zb-btn zb-btn--ghost', text: 'Download my mockup PDF',
        onclick: function () { makePDF(pdfBtn); }
      });
      p.appendChild(section('Mockup sheet', 'Three pages: a full-page front of your belt, a full-page back, and the complete specification — yours to keep or share before you buy.', [
        pdfBtn,
        el('p', { class: 'zb-hint', text: 'The mockup is a production reference, not a photograph. Handmade finishes vary slightly.' })
      ]));

      var qty = el('input', {
        type: 'number', min: '1', max: '20', value: String(state.qty), class: 'zb-input zb-input--qty', 'aria-label': 'Quantity',
        oninput: function () { state.qty = clamp(parseInt(qty.value, 10) || 1, 1, 20); paintPrice(); }
      });
      var ack = el('input', {
        type: 'checkbox', id: 'zb-ack', checked: state.ack || null,
        onchange: function () {
          state.ack = ack.checked; paintPrice(); ui.cta.disabled = !ack.checked || !variantObj().available;
          /* Start building the mockup the moment they approve the design, so
             the PDF is already waiting when they press Add to Cart a few
             seconds later instead of making them sit through the build. */
          if (ack.checked) { try { ensurePdf(); } catch (e) { } }
        }
      });
      p.appendChild(section('Before you add to cart', null, [
        el('div', { class: 'zb-row' }, [el('label', { for: 'zb-ack-qty', text: 'Quantity' }), qty]),
        el('div', { class: 'zb-check' }, [ack, el('label', { for: 'zb-ack', text: 'I have checked my spelling and artwork. Custom belts are made to order and cannot be returned for a change of mind.' })])
      ]));
      ui.cta.disabled = !state.ack || !variantObj().available;
    };

    /* ---------------- mockup PDF ---------------- */
    function captureViews() {
      if (belt3d) {
        return Promise.resolve({
          front: belt3d.capture(2000, 660, 'front', 'image/jpeg', 0.92),
          back: belt3d.capture(2000, 660, 'back', 'image/jpeg', 0.92),
          angle: belt3d.capture(1400, 520, 'angle', 'image/jpeg', 0.9)
        });
      }
      return svgToPng(svgBelt(state, geom), 2000, 660).then(function (u) { return { front: u, back: null, angle: null }; });
    }
    function svgToPng(svg, w, h) {
      return new Promise(function (res) {
        var img = new Image();
        img.onload = function () {
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var x = c.getContext('2d');
          x.fillStyle = '#12131a'; x.fillRect(0, 0, w, h);
          var r = Math.min(w / img.width, h / img.height);
          x.drawImage(img, (w - img.width * r) / 2, (h - img.height * r) / 2, img.width * r, img.height * r);
          res(c.toDataURL('image/jpeg', 0.9));
        };
        img.onerror = function () { res(null); };
        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
      });
    }
    /* Cache of the last mockup built, keyed by a signature of the design, so
       add-to-cart can attach the very same PDF the customer looked at without
       building it twice. */
    var lastPdf = null;        // { sig, blob, name }
    /* Deliberately NOT beltSig(): that one starts with state.mode, and building
       the PDF flips the preview to 3D, which would invalidate the cache the
       instant it was written. This covers everything the mockup actually
       shows, plus the variant and design id printed on the spec page. */
    function pdfSig() {
      var s = [state.template, state.layers, state.finish, state.dualPrimary, state.dualSecondary,
        state.edge, state.strap, state.layout, state.font, state.ink,
        state.bannerStyle, state.bannerColor, state.variant, state.id, state.qty].join('/');
      ZONES.forEach(function (z) { s += '|' + objSig(state.zones[z]); });
      PLATE_KEYS.forEach(function (k) { s += '~' + objSig(state.art[k]); });
      return s;
    }

    /* silent:true builds the PDF without touching the button, the live region
       or the customer's download folder — used to have one ready in the
       background by the time they press Add to Cart. */
    function makePDF(btn, silent) {
      if (busy) return Promise.resolve(null);
      busy = true;
      btn = btn || { textContent: '', disabled: false };
      var label = btn.textContent;
      if (!silent) {
        btn.textContent = 'Building your mockup…'; btn.disabled = true;
        say('Building your mockup PDF.');
      }
      var need = window.jspdf ? Promise.resolve() : loadScript(JSPDF_URL);
      need.then(function () { if (state.mode !== '3d') { state.mode = '3d'; paint(); } return new Promise(function (r) { setTimeout(r, belt3d ? 160 : 700); }); })
        .then(captureViews)
        .then(function (shots) {
          var jsPDF = window.jspdf.jsPDF;
          var doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
          var W = doc.internal.pageSize.getWidth(), H = doc.internal.pageSize.getHeight();
          var M = 34;

          function chrome(title) {
            doc.setFillColor(14, 15, 20); doc.rect(0, 0, W, H, 'F');
            doc.setTextColor(233, 197, 106); doc.setFont('helvetica', 'bold'); doc.setFontSize(18);
            doc.text('ZEES BELTS — LIVE CUSTOM BELT MOCKUP', M, 40);
            doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(185, 185, 196);
            doc.text('Design ID ' + state.id + '   ·   ' + nameOf(TEMPLATES, state.template) + '   ·   ' + new Date().toLocaleString(), M, 56);
            doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(233, 197, 106);
            doc.text(title, M, 78);
          }
          function foot(note) {
            doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); doc.setTextColor(130, 130, 142);
            doc.text(note, M, H - 20);
          }
          /* a full-page belt plate: fit 1600x520 into the page width */
          function bigBelt(img, capTop, capBottom) {
            var availW = W - M * 2, availH = H - 108 - 46;
            var ar = 2000 / 660;
            var w = availW, h = w / ar;
            if (h > availH) { h = availH; w = h * ar; }
            var x = (W - w) / 2, y = 96 + (availH - h) / 2;
            doc.setFillColor(9, 10, 13); doc.rect(x - 8, y - 8, w + 16, h + 16, 'F');
            if (img) { try { doc.addImage(img, 'JPEG', x, y, w, h, undefined, 'FAST'); } catch (e) { } }
            doc.setDrawColor(52, 52, 62); doc.rect(x - 8, y - 8, w + 16, h + 16);
            doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(150, 150, 162);
            if (capBottom) {
              var lines = doc.splitTextToSize(capBottom, w);
              doc.text(lines, x, y + h + 22);
            }
            if (capTop) doc.text(capTop, x, y - 14);
          }

          /* ---- page 1: FRONT, full page ---- */
          chrome('FRONT OF BELT — full view');
          bigBelt(shots.front, null,
            nameOf(TEMPLATES, state.template) + ' · ' + nameOf(LAYERS, state.layers) + ' · '
            + (state.finish === 'dual' ? nameOf(DUAL, state.dualPrimary) + '/' + nameOf(DUAL, state.dualSecondary) + ' dual plating' : nameOf(FINISHES, state.finish))
            + ' · ' + nameOf(EDGES, state.edge) + ' · ' + nameOf(STRAPS, state.strap) + ' strap');
          foot('Rendered mockup for production reference. Handmade plating and enamel vary slightly from screen.'
            + (clamp(state.layers || 1, 1, 4) > PREVIEW_MAX_LAYERS
              ? ' Your belt is built with ' + nameOf(LAYERS, state.layers).toLowerCase() + '; the render shows the artwork at double-layer depth.' : '')
            + ' zeesbelts.com');

          /* ---- page 2: BACK, full page ---- */
          doc.addPage('a4', 'landscape');
          chrome('BACK OF BELT — full view');
          bigBelt(shots.back || shots.front, null,
            'The reverse is plain full-grain leather. Only the backs of the snap fasteners, the eyelet rings and the metal end tip are visible — no plates, no stitching detail beyond the edge run.');
          foot('Rendered mockup for production reference. zeesbelts.com');

          /* ---- page 3: specification ---- */
          doc.addPage('a4', 'landscape');
          chrome('SPECIFICATION');
          var ix = M, iy = 96, w2 = 330, h2 = 123;
          if (shots.angle) {
            doc.setFontSize(8); doc.setTextColor(150, 150, 162);
            doc.text('THREE-QUARTER VIEW', ix, iy - 6);
            try { doc.addImage(shots.angle, 'JPEG', ix, iy, w2, h2, undefined, 'FAST'); } catch (e) { }
            doc.setDrawColor(48, 48, 56); doc.rect(ix, iy, w2, h2);
          }
          doc.setFontSize(7.5); doc.setTextColor(130, 130, 142);
          doc.text(doc.splitTextToSize('Turn the belt in the builder at zeesbelts.com to see every angle, including the full 360° spin, before you order.', w2), ix, iy + h2 + 16);

          var tx = ix + w2 + 34, ty = 112, rows = summaryRows();
          doc.setFontSize(11); doc.setTextColor(233, 197, 106); doc.setFont('helvetica', 'bold');
          doc.text('YOUR CONFIGURATION', tx, 96);
          doc.setFontSize(9); doc.setFont('helvetica', 'normal');
          var colW = W - tx - M, labW = Math.min(148, colW * 0.40), valW = colW - labW - 8;
          rows.forEach(function (r) {
            if (ty > H - 76) return;
            var lines = doc.splitTextToSize(String(r[1]), valW);
            doc.setTextColor(150, 150, 162); doc.text(String(r[0]), tx, ty);
            doc.setTextColor(238, 238, 244); doc.text(lines, tx + labW, ty);
            ty += Math.max(13.5, 11 * lines.length);
          });
          doc.setDrawColor(60, 60, 70); doc.line(tx, ty + 4, tx + colW, ty + 4);
          doc.setFont('helvetica', 'bold'); doc.setFontSize(13); doc.setTextColor(233, 197, 106);
          doc.text('PRICE   ' + money(unitPrice()), tx, Math.min(ty + 24, H - 44));
          foot('Rendered mockup for production reference. Handmade plating and enamel vary slightly from screen. zeesbelts.com');

          var fname = 'zees-belts-mockup-' + state.id + '.pdf';
          /* Keep the blob whether or not we hand it to the customer — this is
             the copy that gets attached to the order so the workshop has the
             approved mockup without anyone emailing it around by hand. */
          try { lastPdf = { sig: pdfSig(), blob: doc.output('blob'), name: fname }; } catch (e) { lastPdf = null; }
          if (!silent) {
            doc.save(fname);
            say('Mockup PDF downloaded — front, back and full specification.');
            track('zb_lcb_mockup_pdf', { template: state.template, layers: state.layers });
          }
        })
        .catch(function (e) {
          console.warn('[zb-lcb] pdf', e);
          if (!silent) say('The mockup could not be built. Please try again.');
        })
        .then(function () {
          busy = false;
          if (!silent) { btn.textContent = label; btn.disabled = false; }
          return lastPdf && lastPdf.sig === pdfSig() ? lastPdf : null;
        });
    }

    /* Resolves with the mockup for the design as it stands now: the cached one
       if it is still current, otherwise a freshly built one. Never rejects —
       a missing mockup must not be able to block a sale. */
    function ensurePdf() {
      if (lastPdf && lastPdf.sig === pdfSig()) return Promise.resolve(lastPdf);
      return makePDF(null, true).catch(function () { return null; });
    }

    /* ---------------- add to cart ---------------- */
    function addToCart() {
      if (busy) return;
      var v = variantObj();
      if (!v || !v.available) { say('That build is unavailable. Please choose another thickness.'); return; }
      if (!state.ack) { state.step = 'review'; paintPanel(); paintNav(); say('Please confirm your spelling and artwork first.'); return; }
      /* Attach the mockup to the order. Until now the PDF only ever existed in
         the customer's own downloads folder, so an order could arrive with no
         picture of what was bought — which is exactly what happened on #2210.
         ensurePdf() usually returns instantly because the background build
         started when they ticked the approval box. It never rejects, and a
         failed mockup must never stop the sale. */
      ui.cta.disabled = true; ui.cta.textContent = 'Preparing your mockup…';
      ensurePdf().then(function (pdf) { addToCart2(pdf); });
    }
    function addToCart2(pdf) {
      if (busy) return;
      var v = variantObj();
      busy = true;
      ui.cta.disabled = true; ui.cta.textContent = 'Adding…';

      var fd = new FormData();
      if (pdf && pdf.blob) fd.append('properties[Mockup PDF]', pdf.blob, pdf.name);
      fd.append('id', v.id);
      fd.append('quantity', String(state.qty));
      /* Build and Plate layers ARE the variant — Shopify already prints
         "Metal Alloy: Brass / Plate Thickness: 4mm / Plate Layers: Single layer"
         on the cart line and the packing slip. Repeating them as properties made
         the line read the same three facts twice. They stay in the on-page review
         panel (which shows no variant options) and in _design_json. */
      var SKIP_ON_CART = { 'Build': 1, 'Plate layers': 1 };
      summaryRows().forEach(function (r) {
        if (SKIP_ON_CART[r[0]]) return;
        fd.append('properties[' + r[0] + ']', r[1]);
      });
      fd.append('properties[Design ID]', state.id);
      fd.append('properties[_design_json]', JSON.stringify(designRecord()));
      PLATE_KEYS.forEach(function (k) {
        if (uploads[k] && state.art[k] && state.art[k].type === 'logo') {
          var nm = (byId(PLATES, k) || {}).name;
          /* production gets the version the customer approved on screen — with
             the background already taken out — and the untouched original too */
          var cleaned = state.art[k].keyed ? canvasBlob(state.art[k].canvas) : null;
          if (cleaned) fd.append('properties[' + nm + ' artwork file]', cleaned, 'logo-' + k + '-transparent.png');
          fd.append('properties[' + nm + (cleaned ? ' artwork original' : ' artwork file') + ']', uploads[k]);
        }
      });

      fetch(CFG.addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'add failed'); return j; }); })
        .then(function () {
          if (strapSurcharge() && CFG.upgradeVariant) {
            return fetch(CFG.addUrl, {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: parseInt(CFG.upgradeVariant, 10), quantity: state.qty,
                properties: { 'Applies to': 'Design ID ' + state.id, 'Texture': nameOf(STRAPS, state.strap) }
              })
            });
          }
        })
        .then(function () {
          track('zb_lcb_add_to_cart', {
            template: state.template, layers: state.layers, finish: state.finish,
            textured: !!strapSurcharge(), value: unitPrice() / 100, qty: state.qty
          });
          say('Added to your cart.');
          try { localStorage.removeItem(STORAGE); } catch (e) { }
          window.location.href = CFG.cartUrl;
        })
        .catch(function (e) {
          console.warn('[zb-lcb] cart', e);
          say('We could not add that to your cart. Please try again, or contact us and quote Design ID ' + state.id + '.');
          busy = false; ui.cta.disabled = false; ui.cta.textContent = 'Add My Custom Belt to Cart';
        });
    }
    function designRecord() {
      var z = {};
      ZONES.forEach(function (k) { if (state.zones[k].text || state.zones[k].style || state.zones[k].color) z[k] = zoneCfg(k); });
      var a = {};
      PLATE_KEYS.forEach(function (k) {
        var x = state.art[k];
        if (x && x.type) a[k] = { type: x.type, id: x.id, x: x.x, y: x.y, s: x.s, r2: x.r2, name: x.name };
      });
      return {
        schema: SCHEMA, id: state.id, ts: new Date().toISOString(),
        template: state.template, layout: state.layout, layers: state.layers,
        finish: state.finish, edge: state.edge, strap: state.strap,
        font: state.font, ink: state.ink, bannerStyle: state.bannerStyle, bannerColor: state.bannerColor,
        variant: state.variant, zones: z, art: a
      };
    }

    /* ---------------- boot ---------------- */
    restore();
    buildShell();
    syncVariant();
    refreshAllArt().then(function () { paint(); });
    paintPanel();
    paint();
    ensureFonts();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { boot3d(); io.disconnect(); } });
      }, { rootMargin: '200px' });
      io.observe(root);
    } else { boot3d(); }
    track('zb_lcb_view', { template: state.template });
    if (CFG.debug) window.ZBLCB = { state: state, geom: function () { return geom; }, data: DATA, belt: function () { return belt3d; }, __fileCanvas: fileCanvas };
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zb-lcb]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
